/* esm.sh - stats.js@0.17.0 */
export * from "/*stats.js@0.17.0/esnext/stats.mjs";
export { default } from "/*stats.js@0.17.0/esnext/stats.mjs";
